import React, {
  createRef,
  CSSProperties,
  useEffect,
  useContext,
  ReactNode
} from 'react';

import './BottomModal.scss';
import Mask from '../Mask';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';
import { ThemeContext } from '../../store/ThemeProvider';
import GorgeousHeader from '../Followee/GorgeousHeader';
import ReactSVG from 'react-svg';
import {alpha} from '../../utils/color';

interface IBottomModal {
  show: boolean;
  onHide: () => void;
  title?: string;
  onlyChild?: boolean; //是否只显示child部分
  child?: ReactNode;
  showStyle?: CSSProperties; // 显示出来的时候需要添加的style
  useMask?: boolean;
  onMaskClick?: () => void;
  wrapClassName?: string;
  renderDelay?: boolean;
  simpleTitle?: boolean;
  portal?:string;
}
const containerEl = document.getElementById('root-page')! as HTMLDivElement;
const BottomModal = function(props: IBottomModal) {
  // useEffect(() => {
  //   document.body.appendChild(containerEl);
  // }, []);
  const wrapperEle = createRef<HTMLDivElement>();

  const themeContext = useContext(ThemeContext);

  useEffect(() => {
    if (props.show) {
      let options = {};
      //console.log(wrapperEle.current);
      if (wrapperEle.current) {
        options = {
          allowTouchMove: (el: Element) => {
            // 不知道为什么这里其实没有正确的效果
            // 只能先放了
            while (el && el !== wrapperEle.current) {
              if (el.classList.contains('inner')) {
                return true;
              }
              el = el.parentNode as Element;
            }
          }
        };
        disableBodyScroll(wrapperEle.current, options);
        window.dispatchEvent(new Event('freeze-refresh'));
      }
      //这个弹窗显示的时候，隐藏掉Video
      window.dispatchEvent(new Event('hide-video'));
    } else {
      wrapperEle.current && enableBodyScroll(wrapperEle.current);
      window.dispatchEvent(new Event('enable-refresh'));
    }

    return () => {
      if(wrapperEle.current) {
        enableBodyScroll(wrapperEle.current);
      }else {
        clearAllBodyScrollLocks();
      }
      window.dispatchEvent(new Event('enable-refresh'));
    };
  }, [props.show]);

  const cls = classNames('bottom-modal inner', {
    hide: !props.show
  });

  const setHtml = (html: string) => {
    return {
      __html: html
    };
  };
  const renderChildren = () => (
    <>
      {props.title ? <GorgeousHeader title={String(props.title)} simple={props.simpleTitle} /> : null}
      <div className="inner">
        {typeof props.child === 'string' ? (
          <div
            className={'custom-html'}
            style={{ width: 330, margin: '12px auto' }}
            dangerouslySetInnerHTML={setHtml(props.child)}
          />
        ) : (
          props.child
        )}
      </div>
      <div
        className="x-container"
        style={{ borderColor: themeContext.backgroundColor }}
      >
        <ReactSVG
          src={require('../../svg/x.svg')}
          className="x"
          style={{ fill: themeContext.h2Color }}
          onClick={props.onHide}
        />
      </div>
    </>
  );

  const { backgroundColor, componentColor } = useContext(ThemeContext);
  let styles = props.show ? props.showStyle : {};
  styles = styles || {};
  Object.assign(styles, {
    backgroundColor: alpha(backgroundColor, 1)
  });

  const wrapperCls = classNames('bottom-modal-wrapper', {
    hide: !props.show
  });
  return createPortal(
    <div className={wrapperCls + ' ' + props.wrapClassName}>
      {props.useMask && props.show && (
        <div className="mask" onClick={props.onMaskClick} />
      )}
      <div
        ref={wrapperEle}
        className={cls}
        onClick={e => e.stopPropagation()}
        style={styles}
      >
        {props.onlyChild ? props.child : renderChildren()}
      </div>
    </div>,
    props.portal ? document.querySelector(props.portal) as HTMLElement : containerEl
  );
};

export default BottomModal;
